import {Box, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import InfoTooltip from "../../../common/InfoTooltip";

interface PanelFieldProps {
    label: string
    hint?: string
    children: React.ReactNode
}

export function PanelField({label, hint, children}: PanelFieldProps) {
    return (
        <Stack gap={1}>
            <Stack direction={'row'} alignItems={'center'}>
                <Typography variant={'body2'} fontWeight={500}>
                    {label}
                </Typography>
                {hint && <InfoTooltip title={hint}/>}
            </Stack>
            {children}
        </Stack>
    );
}

export function PanelSection({icon, title, children}: {
    icon?: React.ReactNode,
    title: string,
    children: React.ReactNode
}) {
    return (
        <Stack gap={2.5}>
            <Stack direction={'row'} alignItems={'center'} gap={1}>
                {!!icon && (
                    <Box sx={{color: 'text.secondary', display: 'flex'}}>
                        {icon}
                    </Box>
                )}
                <Typography variant={'subtitle2'} fontWeight={700} sx={{fontSize: 15}}>
                    {title}
                </Typography>
            </Stack>
            <Stack gap={2.5}>
                {children}
            </Stack>
        </Stack>
    );
}

export function PanelHint({children}: {children: React.ReactNode}) {
    return (
        <Typography color={'text.secondary'} variant={'body2'}>
            {children}
        </Typography>
    );
}
